module.exports = __webpack_public_path__ + "img/keycap-digit-three.e61d6beb.png";